"use strict";

var _interopRequireWildcard = require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _objectSpread2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var order = _interopRequireWildcard(require("@/api/order"));
var _orderType = require("@/types/orderType");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      visible: false,
      form: {},
      rules: {
        trackingCode: {
          required: true,
          message: "Required",
          trigger: "submit"
        }
      },
      imeiReceiveId: null,
      loading: false,
      orderData: null
    };
  },
  created: function created() {},
  methods: {
    submitData: function submitData() {
      var _this = this;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var data, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$refs.form.validate();
            case 2:
              _this.loading = true;
              _context.prev = 3;
              data = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this.orderData), {}, {
                status: _orderType.orderStatus.Shipped,
                trackingCode: _this.form.trackingCode
              });
              _context.next = 7;
              return order.update(_this.orderData.id, {
                order: data
              });
            case 7:
              res = _context.sent;
              _this.$message.success("Approve successfully");
              _this.visible = false;
              _this.$emit("submit-ok");
            case 11:
              _context.prev = 11;
              _this.loading = false;
              return _context.finish(11);
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[3,, 11, 14]]);
      }))();
    },
    handleOpen: function handleOpen(data) {
      this.orderData = data;
      this.form = {};
      this.visible = true;
    }
  }
};